import cn from 'bem-cn';

import { Stack } from '../../UI';
import { CourseCard } from '../../CourseCard/CourseCard';

import { ChallengeInfoFooterProps } from './ChallengeInfoFooter.types';
import './ChallengeInfoFooter.scss';

const b = cn('challenge-info-footer');

export const ChallengeInfoFooter = (props: ChallengeInfoFooterProps) => {
    const { courses } = props;

    return (
        <Stack spacing={16} className={b()}>
            <h2 className={b('title')}>Что-то не получается? Можем помочь</h2>
            <Stack spacing={24}>{courses?.map(course => <CourseCard key={course.id} course={course} />)}</Stack>
        </Stack>
    );
};
